'use client';

import Link from 'next/link';

import { User } from '@supabase/supabase-js';

import { PersonalAccountDropdown } from '@kit/accounts/personal-account-dropdown';
import { useSignOut } from '@kit/supabase/hooks/use-sign-out';
import { useUser } from '@kit/supabase/hooks/use-user';
import { cn } from '@kit/ui/utils';

import LogoGradient from '~/components/branding/logo-gradient';
import featuresFlagConfig from '~/config/feature-flags.config';
import pathsConfig from '~/config/paths.config';

import Drawer from '../drawer';
import Menu from '../menu';

const paths = {
  home: pathsConfig.app.home,
};

const features = {
  enableThemeToggle: featuresFlagConfig.enableThemeToggle,
};

export default function Header(props: { user: User | null }) {
  const signOut = useSignOut();
  const user = useUser(props.user);
  const userData = user.data ?? props.user ?? null;

  return (
    <header
      className={
        'dark fixed left-0 top-0 z-50 w-full px-6 pt-6 lg:px-0 lg:pt-5'
      }
    >
      <div
        className={cn(
          'container mx-auto flex h-[56px] items-center justify-between rounded-full px-6 py-2 backdrop-blur-md backdrop-saturate-150 lg:h-[60px] lg:w-fit lg:min-w-[783px] lg:py-2 lg:pl-8 lg:pr-2',
          'border border-white/10 bg-white/10',
        )}
      >
        <Link
          href="/"
          title="brand-logo"
          className="relative mr-6 flex items-center space-x-2"
        >
          <LogoGradient className="h-[22px] w-auto" />
        </Link>

        <div className="flex items-center">
          <div className="hidden lg:block">
            <div className="flex items-center">
              <nav>
                <Menu user={userData} />
              </nav>

              <div className="flex gap-2"></div>
            </div>
          </div>
            <Link
              href="/auth/sign-in"
              className={cn(
                `mr-6 flex h-10 w-[70px] items-center justify-center rounded-3xl bg-white text-sm font-semibold text-background lg:hidden`,
                userData && 'hidden pointer-events-none',
              )}
            >
              Login
            </Link>
          <div className="mt-2 block cursor-pointer lg:hidden">
            <Drawer user={userData} />
          </div>
          {userData && (
            <div className="ml-2">
              <PersonalAccountDropdown
                showProfileName={false}
                paths={paths}
                features={features}
                user={userData}
                signOutRequested={() => signOut.mutateAsync()}
              />
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
